export default __webpack_public_path__ + "static/media/005-smartphone.140fbb1a.png";